import React from 'react';
import '../styles/Footer.css';
import { useTheme, useThemeColors } from '../ThemeContext';

const Footer: React.FC = () => {
  const theme = useThemeColors();
  const themeName = useTheme();
  return (
    <footer className="footer" style={{ background: theme.footerBackground }}>
      <div className="footer-content">
        {themeName === 'leafcall'
          ? <img src="robot.svg" alt="Logo" className="footer-phone-icon" />
          : <img src="phone.png" alt="Phone" className="footer-phone-icon" />
        }
        <p style={{ color: 'white' }}>{themeName === 'leafcall' ? 'Leaf Call AI' : 'Clear Answer AI'} &copy; 2024</p>
      </div>
    </footer>
  );
};

export default Footer;